import {defineStore} from "pinia/dist/pinia";

export const useMobileTutorialStore = defineStore('mobile-tutorial', {
    state: () => ({
        currentPage: 0,
    })
});
